import standard from '@/config/service/standard';
import Service from '@/services/Services';
import store from '@/store/index'

/**
 * @typedef {Http}
 */
export default class Http extends Service {
  /**
   * @param {String} path
   * @param {Object} options
   * @param {Object} http
   */
  constructor(path, options = {}, http = null) {
    super(options);
    this.path = path;
    this.http = http || standard;
  }

  /**
   * @param {String} path
   * @param {Object} options
   */
  static build(path, options) {
    return new this(path, options);
  }

  /**
   * @returns {Object}
   */

  getHttp() {

    if (store.getters.isAuthenticated) {
      this.http.defaults.headers.common['Authorization'] = store.state.auth.access_token;
    } else {
      delete this.http.defaults.headers.common['Authorization'];
    }

    const panelId = store.getters.setPanel;
    const userId = store.getters.getProfile && store.getters.getProfile.id;
    const isOwnPanel =
      panelId === null ||
      panelId === '' ||
      panelId === 0 ||
      panelId === '0' ||
      userId == null ||
      String(panelId) === String(userId);

    if (!isOwnPanel) {
      this.http.defaults.headers.common['X-Parent-User-ID'] = panelId;
    } else {
      delete this.http.defaults.headers.common['X-Parent-User-ID'];
    }
    
    this.http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    return this.http;
  }

  /**
   * @param {String} url
   * @param {Object} config
   * @returns {*|Promise<any>}
   */
  get(url, config = {}) {
    return this.getHttp()
      .get(this.constructor.normalize(this.path, url), config)
      .then(this.constructor.then);
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @param {Object} config
   * @returns {*|Promise<any>}
   */
  post(url, data, config = {}) {
    return this.getHttp()
      .post(this.constructor.normalize(this.path, url), data, config)
      .then(this.constructor.then);
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @param {Object} config
   * @returns {*|Promise<any>}
   */
  put(url, data, config = {}) {
    return this.getHttp()
      .put(this.constructor.normalize(this.path, url), data, config)
      .then(this.constructor.then);
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @param {Object} config
   * @returns {*|Promise<any>}
   */
  patch(url, data, config = {}) {
    return this.getHttp()
      .patch(this.constructor.normalize(this.path, url), data, config)
      .then(this.constructor.then)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  delete(url, config = {}) {
    return this.getHttp()
      .delete(this.constructor.normalize(this.path, url), config)
      .then(this.constructor.then);
  }

  /**
   * @param {Object} response
   * @returns {Object}
   */
  static then(response) {
    if (!response.data) {
      return {};
    }
    if (typeof response.data === 'string' &&
      (!response.data.includes('�') && !response.data.includes('%PDF'))) {
      try {
        return JSON.parse(response.data);
      } catch (e) {
        return response.data;
      }
    }
    return response.data;
  }

  /**
   * @param {String} start
   * @param {String} end
   * @returns {String}
   */
  static normalize(start, end) {
    if (end.length > 0) {
      if (end[0] != '?')
        return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1');
      else
        return `${start}${end}`.replace(/([^:]\/)\/+/g, '$1');
    } else {
      return `${start}`.replace(/([^:]\/)\/+/g, '$1');
    }
  }
}